/*
 * Thanks: Ignacio F. López Vico
 */
t_jp.l = {
    'Close without saving?': 'Cerrar sin guardar?',
    'You have made a change to the translation. Are you sure you want to discard it?': 'Has cambiado la traducion. Estas seguro que lo quieres eliminar?',
    'History': 'Historia',
    'Loading...': 'Cargando...',
    'Translated': 'Traducido',
    'By': 'Por',
    'At': 'En',
    'google': 'google',
    'bing': 'bing',
    'apertium': 'apertium',
    'manual translation': 'traducción manual',
    'bing suggest': 'sugerencia de bing',
    'google suggest': 'sugerencia de google',
    'apertium suggest': 'sugerencia de apertium',
    'Edit Translation': 'Editar traducción',
    'Original text': 'Texto original',
    'read alternate translations': 'lee traducciónes alternativas',
    'previous translation': 'traducción anterior',
    'find on page': 'encuentra en la pagina',
    'next translation': 'siguiente traducción',
    'Translate to': 'Traducir a',
    'view translation log': 'muestra diario de traducion',
    'virtual keyboard': 'teclado virtual',
    'approve translation': 'aprueba traducion',
    'delete': 'eliminar',
    'Discard': 'Descartar',
    'Cancel': 'Cancelar'
};